import { useCallback } from "react";
import { useToast } from "@chakra-ui/react";
import i18n from "../../../../i18n";
import { useStores } from "../../../../stores/setup/use-store";
import { IOperationRuleLocation } from "../../../../stores/data/operationRuleLocations/OperationRuleLocationModel";

export function useLocationOrdering() {
	const {
		dataStores: {
			operationRuleLocationStore,
			oceanWeatherIntelligenceStore,
		},
	} = useStores();

	const toast = useToast();

	const handleSaveOrder = useCallback(
		(newData: IOperationRuleLocation[]) => {
			let dashboardId;

			if (newData.length) {
				dashboardId = newData[0].operationRuleId;
				operationRuleLocationStore.setOperationRuleLocations(newData);
			}

			if (dashboardId) {
				const ids = newData.map((item: IOperationRuleLocation) => item.id);

				operationRuleLocationStore.updateOperationRuleLocationOrder({
					dashboardId,
					idsInOrder: ids,
				});

				oceanWeatherIntelligenceStore.setChangeForUpdate({
					update: true,
					expiration: 0,
				});
			} else {
				toast({
					title: i18n.t("oceanWeatherIntelligence.errorWhileSaveSort"),
					status: "error",
					position: "top",
					isClosable: true,
				});
			}
		},
		[operationRuleLocationStore, oceanWeatherIntelligenceStore, toast]
	);

	return {
		handleSaveOrder,
	};
}
